import { Toast } from "radix-ui";
import { useTranslation } from "react-i18next";

const ToastTitle = ({ type }) => {
  const { t } = useTranslation();

  return (
    <Toast.Title
      className={`font-league-bold ${
        type === "success" ? "text-green-500" : "text-red-500"
      }`}
    >
      {type === "success" ? t("toast.success") : t("toast.error")}
    </Toast.Title>
  );
};

export default ToastTitle;
